import script from "./splashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./splashScreen.vue?vue&type=script&setup=true&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=cc9e4882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc9e4882"]])

export default __exports__